(function () {
  var roots = Array.prototype.slice.call(document.querySelectorAll('.rs-main-product[id]'));
  if (!roots.length) return;

  function formatMoney(cents, moneyFormat) {
    return moneyFormat.replace(/\{\{(\s*amount[^}]*)\}\}/g, function (_, tag) {
      var amount = (cents / 100).toFixed(2);
      if (tag.indexOf('no_decimals') !== -1) amount = Math.round(cents / 100).toString();
      else if (tag.indexOf('with_comma_separator') !== -1) amount = amount.replace('.', ',');
      return amount;
    });
  }

  function initMainProduct(root) {
    var rootId = root.id || '';
    if (!rootId) return;

    var sid = rootId.replace('rs-main-product-', '');
    var bar = document.getElementById('rs-mobile-bar-' + sid);

    var mainItems = Array.prototype.slice.call(root.querySelectorAll('[data-rs-main-item]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-rs-thumb]'));

    function activate(mediaId) {
      mediaId = String(mediaId);
      mainItems.forEach(function (item) {
        var on = item.getAttribute('data-media-id') === mediaId;
        item.hidden = !on;
        item.classList.toggle('is-active', on);
      });
      thumbs.forEach(function (btn) {
        var on = btn.getAttribute('data-media-id') === mediaId;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activate(btn.getAttribute('data-media-id'));
      });
    });

    function initZoom() {
      var dlg = root.querySelector('[data-rs-zoom-dialog]');
      var zoomImg = root.querySelector('[data-rs-zoom-img]');
      var closeBtn = root.querySelector('[data-rs-zoom-close]');
      var prevBtn = root.querySelector('[data-rs-zoom-prev]');
      var nextBtn = root.querySelector('[data-rs-zoom-next]');
      var openBtns = Array.prototype.slice.call(root.querySelectorAll('[data-rs-zoom-open]'));
      if (!dlg || !zoomImg || !openBtns.length) return;

      var slides = openBtns.map(function (btn) {
        return {
          src: btn.getAttribute('data-zoom-src') || '',
          alt: btn.getAttribute('data-zoom-alt') || ''
        };
      });
      var currentIndex = 0;

      function updateNavState() {
        if (prevBtn) prevBtn.disabled = currentIndex === 0;
        if (nextBtn) nextBtn.disabled = currentIndex === slides.length - 1;
      }

      function showSlide(index) {
        if (index < 0 || index >= slides.length) return;
        currentIndex = index;
        var slide = slides[currentIndex];
        zoomImg.src = slide.src;
        zoomImg.alt = slide.alt;
        updateNavState();
        zoomImg.classList.remove('is-changing');
        void zoomImg.offsetWidth;
        zoomImg.classList.add('is-changing');
      }

      function lockBodyScroll() {
        document.body.style.overflow = 'hidden';
      }

      function unlockBodyScroll() {
        document.body.style.overflow = '';
      }

      openBtns.forEach(function (btn, index) {
        btn.addEventListener('click', function () {
          showSlide(index);
          try {
            if (typeof dlg.showModal === 'function') dlg.showModal();
            else dlg.setAttribute('open', 'open');
          } catch (err) {
            dlg.setAttribute('open', 'open');
          }
          lockBodyScroll();
        });
      });

      if (prevBtn) prevBtn.addEventListener('click', function () { showSlide(currentIndex - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { showSlide(currentIndex + 1); });

      function closeZoom() {
        if (typeof dlg.close === 'function') dlg.close();
        else dlg.removeAttribute('open');
      }

      dlg.addEventListener('close', unlockBodyScroll);

      if (closeBtn) closeBtn.addEventListener('click', closeZoom);

      dlg.addEventListener('click', function (e) {
        if (e.target === dlg) closeZoom();
      });

      dlg.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') showSlide(currentIndex + 1);
        else if (e.key === 'ArrowLeft') showSlide(currentIndex - 1);
      });

      if (slides.length > 1) {
        var touchStartX = 0;
        var touchStartY = 0;

        zoomImg.addEventListener('touchstart', function (e) {
          touchStartX = e.changedTouches[0].clientX;
          touchStartY = e.changedTouches[0].clientY;
        }, { passive: true });

        zoomImg.addEventListener('touchend', function (e) {
          var dx = e.changedTouches[0].clientX - touchStartX;
          var dy = e.changedTouches[0].clientY - touchStartY;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
          showSlide(dx < 0 ? currentIndex + 1 : currentIndex - 1);
        }, { passive: true });
      }
    }

    initZoom();

    var leftPrice = root.querySelector('[data-rs-left-price]');
    var barPrice = bar && bar.querySelector('[data-rs-bar-price]');
    var fmt = root.querySelector('[data-rs-money-format]');
    var moneyFormat = (fmt && fmt.getAttribute('data-rs-money-format')) || root.getAttribute('data-rs-money-format-default') || '{{amount}}';

    function onVariantChange(e) {
      var targetRoot = e && e.detail && e.detail.form && e.detail.form.closest && e.detail.form.closest('.rs-main-product');
      if (targetRoot && targetRoot !== root) return;

      var v = e && e.detail && e.detail.variant;
      if (!v) return;

      if (v.featured_media && v.featured_media.id) activate(v.featured_media.id);
      if (v.price != null) {
        var formatted = formatMoney(v.price, moneyFormat);
        if (leftPrice) leftPrice.textContent = formatted;
        if (barPrice) barPrice.textContent = formatted;
      }
    }

    document.addEventListener('rs:variant-change', onVariantChange);

    var realSubmit = root.querySelector('[data-rs-submit]');
    var extCtaBtns = Array.prototype.slice.call(root.querySelectorAll('[data-rs-ext-cta]'));
    extCtaBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (realSubmit) realSubmit.click();
      });
    });

    function initMobileNav() {
      if (!bar) return;

      function pruneFaqNavLink() {
        var faqA = bar.querySelector('a[data-rs-faq-nav]');
        if (faqA && !document.getElementById('rs-faq')) faqA.remove();
      }
      pruneFaqNavLink();

      var navLinks = Array.prototype.slice.call(bar.querySelectorAll('a[data-rs-nav]'));

      function buildNavTargets() {
        return navLinks
          .map(function (a) {
            var href = a.getAttribute('href') || '';
            var id = href.charAt(0) === '#' ? href.slice(1) : '';
            return { id: id, nav: a.getAttribute('data-rs-nav') };
          })
          .filter(function (t) {
            return t.id && t.nav && document.getElementById(t.id);
          });
      }

      function setNavActive(navKey) {
        navLinks.forEach(function (a) {
          a.classList.toggle('is-active', a.getAttribute('data-rs-nav') === navKey);
        });
      }

      function updateNavFromPositions() {
        var targets = buildNavTargets();
        if (!targets.length) return;
        var barH = bar.offsetHeight;
        var threshold = Math.min(barH + 32, window.innerHeight * 0.42);
        var active = targets[0].nav;
        targets.forEach(function (t) {
          var el = document.getElementById(t.id);
          if (el && el.getBoundingClientRect().top <= threshold) active = t.nav;
        });
        setNavActive(active);
      }

      var allAnchors = Array.prototype.slice.call(root.querySelectorAll('a[href^="#"]'));
      allAnchors.forEach(function (a) {
        a.addEventListener('click', function () {
          var href = a.getAttribute('href');
          if (!href || href.charAt(0) !== '#') return;
          if (!document.getElementById(href.slice(1))) return;
          var navKey = a.getAttribute('data-rs-nav');
          if (navKey) setNavActive(navKey);
        });
      });

      var spyObserver = new IntersectionObserver(
        function () {
          updateNavFromPositions();
        },
        { root: null, rootMargin: '0px', threshold: [0, 0.05, 0.1, 0.2, 0.35, 0.5, 0.65, 0.8, 1] }
      );
      buildNavTargets().forEach(function (t) {
        var el = document.getElementById(t.id);
        if (el) spyObserver.observe(el);
      });

      window.addEventListener('resize', updateNavFromPositions, { passive: true });
      updateNavFromPositions();
    }

    initMobileNav();
  }

  roots.forEach(initMainProduct);
})();
